import { render, staticRenderFns } from "./Lightspeed.vue?vue&type=template&id=bf4784ca"
import script from "./Lightspeed.vue?vue&type=script&lang=js"
export * from "./Lightspeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports